import React, { useState, useEffect, useRef } from 'react';

import './HowItWorks.scss';
import step1 from '../../assets/steps/step-1.jpg';
import step2 from '../../assets/steps/step-2.jpg';
import step3 from '../../assets/steps/step-3.jpg';

const steps = [
  {
    title: 'Show us',
    body: 'Tell us who\'s sending you junk mail — takes under a minute.',
    image: step1,
  },
  {
    title: 'We act',
    body: 'Wabi sends the legal opt-out request on your behalf. No calls, no letters from you.',
    image: step2,
  },
  {
    title: 'It stops',
    body: 'Watch each sender go quiet in your dashboard. 86% less junk in about 4 weeks.',
    image: step3,
  },
];

const timeline = [
  { label: 'Day 0', caption: 'Sign up' },
  { label: 'Week 1', caption: 'First opt-outs land' },
  { label: 'Week 4', caption: '86% less junk' },
];

const AUTO_ADVANCE_MS = 5000;

const HowItWorks = () => {
  const [active, setActive] = useState(0);
  const [paused, setPaused] = useState(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (paused) return undefined;
    intervalRef.current = setInterval(() => {
      setActive((prev) => (prev + 1) % steps.length);
    }, AUTO_ADVANCE_MS);
    return () => clearInterval(intervalRef.current);
  }, [paused]);

  const selectStep = (i) => {
    setActive(i);
    setPaused(true);
  };

  return (
    <section id="how-it-works" className="HowItWorks">
      <div className="HowItWorks__header">
        <h2>How it works</h2>
        <p>Three steps. About an hour of your time, total.</p>
      </div>

      <div className="HowItWorks__stage">
        <ol className="HowItWorks__steps">
          {steps.map((s, i) => (
            <li
              key={s.title}
              className={`HowItWorks__step${i === active ? ' is-active' : ''}`}
            >
              <button
                type="button"
                className="HowItWorks__stepButton"
                onClick={() => selectStep(i)}
                aria-pressed={i === active}
              >
                <span className="HowItWorks__stepNum">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <span className="HowItWorks__stepText">
                  <span className="HowItWorks__stepTitle">{s.title}</span>
                  <span className="HowItWorks__stepBody">{s.body}</span>
                </span>
              </button>
              <div className="HowItWorks__stepImage">
                <img src={s.image} alt={`Step ${i + 1}: ${s.title}`} loading="lazy" />
              </div>
            </li>
          ))}
        </ol>

        <div className="HowItWorks__panel" aria-hidden="true">
          {steps.map((s, i) => (
            <img
              key={s.title}
              src={s.image}
              alt=""
              className={`HowItWorks__panelImg${i === active ? ' is-active' : ''}`}
              loading="lazy"
            />
          ))}
        </div>
      </div>

      <ol className="HowItWorks__timeline" aria-label="Typical timeline">
        {timeline.map((t) => (
          <li key={t.label}>
            <span className="HowItWorks__timelineLabel">{t.label}</span>
            <span className="HowItWorks__timelineCaption">{t.caption}</span>
          </li>
        ))}
      </ol>
    </section>
  );
};

export default HowItWorks;
